import React, { useEffect, createContext, useState } from 'react'
import { TemplateContainer } from '../common/TemplateContainer'
import { GlobalStyles } from '../common/globalStyles'
import { getAnalysisTypeFromParams, getAssetLink } from '../common/utils'
import { AssetNav, COLAPSED_NAV_WIDTH } from '../assetNav/assetNav'
import { BreadCrumb } from './breadCrumb'
import styled from 'styled-components'
import { TabMenu, TAB_TYPES } from './tabMenu'
import { SensorialTab } from './sensorialTab/sensorialTab'
import { QualityAnalysis } from '../qualityAnalysis/qualityAnalysis'
import { AnalysisEditing } from '../qualityAnalysis/analysisEditing'
import { analysisEditingUrl } from '../qualityAnalysis/analysisUtils'
import { getAssetTree } from '../common/apis'

interface IProps {
    urlParams: string[]
}

export const ParamsContext = createContext<string>('')
export const AssetTreeContext = createContext<CountryData[]>([])
export function QualityMonitoring({ urlParams }: IProps): JSX.Element {
    const [analysisType, setAnalysisType] = useState<AnalysisTypes | ''>('')
    const [selectedAnalysis, setSelectedAnalysis] = useState<AnalysisEvent>()
    const [assetTree, setAssetTree] = useState([])

    useEffect(() => {
        getAssetTree('factory').then(response => {
            setAssetTree(response)
        })
    }, [])

    useEffect(() => {
        if (!TAB_TYPES.includes(urlParams[0])) {
            window.location.href = getAssetLink(TAB_TYPES[0])
        }
        const newAnalysisType = getAnalysisTypeFromParams(urlParams)
        if (analysisType !== newAnalysisType) setAnalysisType(newAnalysisType)
    }, [urlParams, analysisType])

    useEffect(() => {
        if (!urlParams.includes(analysisEditingUrl)) {
            setSelectedAnalysis(null)
        }
        if (urlParams.includes(analysisEditingUrl) && !selectedAnalysis) {
            const newParams = [...urlParams]
            newParams.pop()
            window.location.href = getAssetLink(newParams.join('/'))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlParams])

    const editingAnalysis = urlParams.includes(analysisEditingUrl)

    return (
        <ParamsContext.Provider value={urlParams.join('/')}>
            <AssetTreeContext.Provider value={assetTree}>
                <GlobalStyles />
                <TemplateContainer>
                    <StyledQualityMonitoring
                        style={
                            {
                                '--padding': analysisType || selectedAnalysis ? '0' : COLAPSED_NAV_WIDTH + 'px'
                            } as React.CSSProperties
                        }
                    >
                        <BreadCrumb analysisType={analysisType || selectedAnalysis?.analysisType} />
                        {selectedAnalysis && editingAnalysis ? (
                            <AnalysisEditing selectedAnalysis={selectedAnalysis} />
                        ) : null}
                        {analysisType ? <QualityAnalysis analysisType={analysisType} /> : null}
                        {!analysisType && !selectedAnalysis ? (
                            <React.Fragment>
                                <AssetNav />
                                <TabMenu />
                                <div className="qualityMonitoring--contentContainer">
                                    <SensorialTab setSelectedAnalysis={setSelectedAnalysis} />
                                </div>
                            </React.Fragment>
                        ) : null}
                    </StyledQualityMonitoring>
                </TemplateContainer>
            </AssetTreeContext.Provider>
        </ParamsContext.Provider>
    )
}

const StyledQualityMonitoring = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-left: var(--padding);
    position: relative;
    .qualityMonitoring {
        &--contentContainer {
            flex-grow: 1;
        }
    }
`
